import React from 'react';
import { formatDuration, formatNumber } from '../utils/adminMetrics';
import {
  ClockIcon,
  FileIcon,
  FileTextIcon,
  GlobeIcon,
  StarIcon,
  UsersIcon,
} from './AdminKpiIcons';

function KpiCard({ label, value, icon }) {
  return (
    <div className="admin-kpi-card">
      <div className="admin-kpi-label">{label}</div>
      <div className="admin-kpi-body">
        <div className="admin-kpi-value">{value}</div>
        {icon}
      </div>
    </div>
  );
}

function AdminMetricsCards({ summary }) {
  if (!summary) return null;

  const total = summary?.total_translations ?? 0;
  const words = summary?.total_words_translated ?? 0;
  const avgSeconds = summary?.avg_processing_seconds;
  const activeUsers = summary?.active_users ?? 0;
  const filesProcessed = summary?.files_processed ?? 0;
  const reviewedCount = summary?.reviewed_count ?? 0;

  return (
    <div className="admin-kpi-row" aria-label="Admin summary metrics">
      <KpiCard
        label="Total Translation Requests"
        value={formatNumber(total)}
        icon={<FileTextIcon />}
      />
      <KpiCard
        label="Total Words Translated"
        value={formatNumber(words)}
        icon={<GlobeIcon />}
      />
      <KpiCard
        label="Avg Processing Time"
        value={formatDuration(avgSeconds)}
        icon={<ClockIcon />}
      />
      <KpiCard
        label="Active Users"
        value={formatNumber(activeUsers)}
        icon={<UsersIcon />}
      />
      <KpiCard
        label="Files Processed"
        value={formatNumber(filesProcessed)}
        icon={<FileIcon />}
      />
      <KpiCard
        label="Reviews Total"
        value={formatNumber(reviewedCount)}
        icon={<StarIcon />}
      />
    </div>
  );
}

export default AdminMetricsCards;
